import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { suppressGlobalErrorFeedback } from '@core/interceptors';
import { environment, endpoints } from '@environment';

@Injectable({ providedIn: 'root' })
export class GdprService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/${endpoints.v1.gdpr}`;

  export(): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/export`, null, {
      responseType: 'blob',
      context: suppressGlobalErrorFeedback(),
    });
  }
}
